import NotificationsConfigCard from "./NotificationsConfigCard";

export { NotificationsConfigCard };
